// LOGIN_DRAGAO_3110 (GROK2 31/10): fundo dragão neon 3D no login (1 de 3 imagens aleatória por carga).
// Parallax/tilt com o mouse; giroscópio ou flutuação suave no celular; pulso de brilho neon; overlay escuro.
// Respeita prefers-reduced-motion. Desliga com private/LOGIN_DRAGAO_3110_OFF (flag login_dragao_3110).
import React, { useEffect, useMemo, useRef } from 'react';
import './LoginDragao3110.css';

const IMGS = [1, 2, 3];

export default function LoginDragao3110() {
  const ref = useRef(null);
  const n = useMemo(() => {
    try { const q = new URLSearchParams(window.location.search).get('dragao'); if (IMGS.includes(Number(q))) return Number(q); } catch (_) { /* noop */ }
    return IMGS[Math.floor(Math.random() * IMGS.length)];
  }, []);
  useEffect(() => {
    const el = ref.current; if (!el) return undefined;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return undefined;
    let raf = 0; let tx = 0; let ty = 0; let cx = 0; let cy = 0;
    const tick = () => { cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      el.style.setProperty('--dx', cx.toFixed(3)); el.style.setProperty('--dy', cy.toFixed(3));
      raf = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.001 ? requestAnimationFrame(tick) : 0; };
    const kick = () => { if (!raf) raf = requestAnimationFrame(tick); };
    const onMove = (e) => { tx = (e.clientX / window.innerWidth) * 2 - 1; ty = (e.clientY / window.innerHeight) * 2 - 1; kick(); };
    const onOri = (e) => { if (e.gamma == null) return; el.classList.add('ldg--gyro');
      tx = Math.max(-1, Math.min(1, e.gamma / 30)); ty = Math.max(-1, Math.min(1, (e.beta - 45) / 30)); kick(); };
    const fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
    if (fine) window.addEventListener('mousemove', onMove, { passive: true });
    else window.addEventListener('deviceorientation', onOri, { passive: true });
    return () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('deviceorientation', onOri); if (raf) cancelAnimationFrame(raf); };
  }, []);
  return (
    <div className="ldg" ref={ref} aria-hidden="true" data-dragao={n}>
      <picture className="ldg-pic">
        <source media="(max-width: 700px)" srcSet={`/dragao/dragao${n}_m.webp`} type="image/webp" />
        <img className="ldg-img" src={`/dragao/dragao${n}.webp`} alt="" decoding="async" fetchpriority="high" />
      </picture>
      <div className="ldg-glow" />
      <div className="ldg-overlay" />
    </div>
  );
}
